<template>
    <div class="banner text-center" v-if="show">
        <i class="fas fa-exclamation-triangle"></i><span v-html="$t('components.dismissibleBanner')"></span><a href="http://ferienwohnungen-tessin.ch">http://www.ferienwohnungen-tessin.ch</a><i class="fas fa-exclamation-triangle"></i>
        <button type="button" class="close" @click="show = false">
            <span aria-hidden="true"><i class="fas fa-times"></i></span>
        </button>
    </div>
</template>

<script>
export default {
    name: "DismissibleBanner",
    data() {
        return {
            show: true
        }
    }
}
</script>

<style lang="scss" scoped>
.banner {
    background-color: red;
    color: white;
    padding: 24px;
    font-size: 20px;

    a {
        color: white;
        text-decoration: underline;
    }
}

.fa-times {
    color: white;
}

.fa-exclamation-triangle {
    padding-left: 8px;
    padding-right: 8px;
}
</style>